var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircleMutedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 101C37.6445 101 25.0883 95.7992 15.6445 86.3555C6.20078 76.9117 1 64.3555 1 51C1 37.6445 6.20098 25.0885 15.6445 15.6445C25.0881 6.20059 37.6445 1 51 1C64.3555 1 76.9117 6.20078 86.3555 15.6445C95.7992 25.0883 101 37.6445 101 51C101 64.3555 95.799 76.9115 86.3555 86.3555C76.9119 95.7994 64.3555 101 51 101ZM51 7.25C26.8762 7.25 7.25 26.8762 7.25 51C7.25 75.1238 26.8762 94.75 51 94.75C75.1238 94.75 94.75 75.1238 94.75 51C94.75 26.8762 75.1238 7.25 51 7.25Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 47.875C46.6922 47.875 43.1875 44.3703 43.1875 40.0625C43.1875 35.7547 46.6922 32.25 51 32.25C55.3078 32.25 58.8125 35.7547 58.8125 40.0625C58.8125 41.7883 60.2115 43.1875 61.9375 43.1875C63.6635 43.1875 65.0625 41.7883 65.0625 40.0625C65.0625 33.3826 60.3793 27.7797 54.125 26.3543V22.875C54.125 21.1492 52.726 19.75 51 19.75C49.274 19.75 47.875 21.1492 47.875 22.875V26.3543C41.6207 27.7797 36.9375 33.3826 36.9375 40.0625C36.9375 47.8166 43.2459 54.125 51 54.125C55.3078 54.125 58.8125 57.6297 58.8125 61.9375C58.8125 66.2453 55.3078 69.75 51 69.75C46.6922 69.75 43.1875 66.2453 43.1875 61.9375C43.1875 60.2117 41.7885 58.8125 40.0625 58.8125C38.3365 58.8125 36.9375 60.2117 36.9375 61.9375C36.9375 68.6174 41.6207 74.2203 47.875 75.6457V79.125C47.875 80.8508 49.274 82.25 51 82.25C52.726 82.25 54.125 80.8508 54.125 79.125V75.6457C60.3793 74.2203 65.0625 68.6174 65.0625 61.9375C65.0625 54.1834 58.7541 47.875 51 47.875Z",
    fill: "#EEEEEE",
    stroke: "#EEEEEE",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircleMutedGrey);
export default __webpack_public_path__ + "static/media/dollar-circle-muted-grey.9fbf4c19585db9597ab3bfb8b9ef5876.svg";
export { ForwardRef as ReactComponent };